/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.0.4.0 (NJsonSchema v10.0.21.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

export class Client {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param deviceId (optional) 
     * @return Success
     */
    getDeviceInfo(deviceId: string | null | undefined): Promise<GetDeviceInfoResponse> {
        let url_ = this.baseUrl + "/api/Device/GetDeviceInfo?";
        if (deviceId !== undefined)
            url_ += "DeviceId=" + encodeURIComponent("" + deviceId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetDeviceInfo(_response);
        });
    }

    protected processGetDeviceInfo(response: AxiosResponse): Promise<GetDeviceInfoResponse> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDeviceInfoResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDeviceInfoResponse>(<any>null);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    getDevices(request: any | null | undefined): Promise<GetDevicesResponse> {
        let url_ = this.baseUrl + "/api/Device/GetDevices?";
        if (request !== undefined)
            url_ += "request=" + encodeURIComponent("" + request) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetDevices(_response);
        });
    }

    protected processGetDevices(response: AxiosResponse): Promise<GetDevicesResponse> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDevicesResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDevicesResponse>(<any>null);
    }

    /**
     * @param deviceName (optional) 
     * @param deviceId (optional) 
     * @return Success
     */
    setDeviceName(deviceName: string | null | undefined, deviceId: string | null | undefined): Promise<SetDeviceNameResponse> {
        let url_ = this.baseUrl + "/api/Device/SetDeviceName?";
        if (deviceName !== undefined)
            url_ += "DeviceName=" + encodeURIComponent("" + deviceName) + "&"; 
        if (deviceId !== undefined)
            url_ += "DeviceId=" + encodeURIComponent("" + deviceId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSetDeviceName(_response);
        });
    }

    protected processSetDeviceName(response: AxiosResponse): Promise<SetDeviceNameResponse> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SetDeviceNameResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SetDeviceNameResponse>(<any>null);
    }

    /**
     * @param deviceId (optional) 
     * @return Success
     */
    restartDevice(deviceId: string | null | undefined): Promise<RestartDeviceResponse> {
        let url_ = this.baseUrl + "/api/Device/RestartDevice?";
        if (deviceId !== undefined)
            url_ += "DeviceId=" + encodeURIComponent("" + deviceId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRestartDevice(_response);
        });
    }

    protected processRestartDevice(response: AxiosResponse): Promise<RestartDeviceResponse> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RestartDeviceResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RestartDeviceResponse>(<any>null);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    resetDevice(request: ResetDeviceRequest | null | undefined): Promise<ResetDeviceResponse> {
        let url_ = this.baseUrl + "/api/Device/ResetDevice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processResetDevice(_response);
        });
    }

    protected processResetDevice(response: AxiosResponse): Promise<ResetDeviceResponse> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResetDeviceResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResetDeviceResponse>(<any>null);
    }

    /**
     * @param deviceId (optional) 
     * @return Success
     */
    pairDevice(deviceId: string | null | undefined): Promise<PairDeviceResponse> {
        let url_ = this.baseUrl + "/api/Device/PairDevice?";
        if (deviceId !== undefined)
            url_ += "DeviceId=" + encodeURIComponent("" + deviceId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPairDevice(_response);
        });
    }

    protected processPairDevice(response: AxiosResponse): Promise<PairDeviceResponse> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PairDeviceResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PairDeviceResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getAllEventsDummy(): Promise<AllEvents> {
        let url_ = this.baseUrl + "/api/Events/GetAllEventsDummy";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAllEventsDummy(_response);
        });
    }

    protected processGetAllEventsDummy(response: AxiosResponse): Promise<AllEvents> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AllEvents.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AllEvents>(<any>null);
    }

    /**
     * @param deviceId (optional) 
     * @return Success
     */
    startCamera(deviceId: string | null | undefined): Promise<StartCameraResponse> {
        let url_ = this.baseUrl + "/api/External/StartCamera?";
        if (deviceId !== undefined)
            url_ += "DeviceId=" + encodeURIComponent("" + deviceId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processStartCamera(_response);
        });
    }

    protected processStartCamera(response: AxiosResponse): Promise<StartCameraResponse> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StartCameraResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StartCameraResponse>(<any>null);
    }

    /**
     * @param filename (optional) 
     * @param deviceId (optional) 
     * @return Success
     */
    getFileAsJson(filename: string | null | undefined, deviceId: string | null | undefined): Promise<GetFileAsJsonResponse> {
        let url_ = this.baseUrl + "/api/File/GetFileAsJson?";
        if (filename !== undefined)
            url_ += "Filename=" + encodeURIComponent("" + filename) + "&"; 
        if (deviceId !== undefined)
            url_ += "DeviceId=" + encodeURIComponent("" + deviceId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetFileAsJson(_response);
        });
    }

    protected processGetFileAsJson(response: AxiosResponse): Promise<GetFileAsJsonResponse> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetFileAsJsonResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetFileAsJsonResponse>(<any>null);
    }

    /**
     * @param filename (optional) 
     * @param deviceId (optional) 
     * @return Success
     */
    getFileAsBytes(filename: string | null | undefined, deviceId: string | null | undefined): Promise<GetFileAsBytesResponse> {
        let url_ = this.baseUrl + "/api/File/GetFileAsBytes?";
        if (filename !== undefined)
            url_ += "Filename=" + encodeURIComponent("" + filename) + "&"; 
        if (deviceId !== undefined)
            url_ += "DeviceId=" + encodeURIComponent("" + deviceId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetFileAsBytes(_response);
        });
    }

    protected processGetFileAsBytes(response: AxiosResponse): Promise<GetFileAsBytesResponse> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetFileAsBytesResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetFileAsBytesResponse>(<any>null);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    uploadFileAsJson(request: UploadFileAsJsonRequest | null | undefined): Promise<UploadFileAsJsonResponse> {
        let url_ = this.baseUrl + "/api/File/UploadFileAsJson";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUploadFileAsJson(_response);
        });
    }

    protected processUploadFileAsJson(response: AxiosResponse): Promise<UploadFileAsJsonResponse> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UploadFileAsJsonResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UploadFileAsJsonResponse>(<any>null);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    uploadFileAsBytes(request: UploadFileAsBytesRequest | null | undefined): Promise<UploadFileAsBytesResponse> {
        let url_ = this.baseUrl + "/api/File/UploadFileAsBytes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUploadFileAsBytes(_response);
        });
    }

    protected processUploadFileAsBytes(response: AxiosResponse): Promise<UploadFileAsBytesResponse> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UploadFileAsBytesResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UploadFileAsBytesResponse>(<any>null);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    setRelay(request: SetRelayRequest | null | undefined): Promise<SetRelayResponse> {
        let url_ = this.baseUrl + "/api/Relay/SetRelay";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSetRelay(_response);
        });
    }

    protected processSetRelay(response: AxiosResponse): Promise<SetRelayResponse> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SetRelayResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SetRelayResponse>(<any>null);
    }

    /**
     * @param deviceId (optional) 
     * @return Success
     */
    getRelays(deviceId: string | null | undefined): Promise<GetRelaysResponse> {
        let url_ = this.baseUrl + "/api/Relay/GetRelays?";
        if (deviceId !== undefined)
            url_ += "DeviceId=" + encodeURIComponent("" + deviceId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetRelays(_response);
        });
    }

    protected processGetRelays(response: AxiosResponse): Promise<GetRelaysResponse> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetRelaysResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetRelaysResponse>(<any>null);
    }

    /**
     * @param deviceId (optional) 
     * @return Success
     */
    getFirmwareInfo(deviceId: string | null | undefined): Promise<GetFirmwareInfoResponse> {
        let url_ = this.baseUrl + "/api/Software/GetFirmwareInfo?";
        if (deviceId !== undefined)
            url_ += "DeviceId=" + encodeURIComponent("" + deviceId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetFirmwareInfo(_response);
        });
    }

    protected processGetFirmwareInfo(response: AxiosResponse): Promise<GetFirmwareInfoResponse> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetFirmwareInfoResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetFirmwareInfoResponse>(<any>null);
    }

    /**
     * @param deviceId (optional) 
     * @return Success
     */
    updateToLatestVersion(deviceId: string | null | undefined): Promise<UpdateToLatestVersionResponse> {
        let url_ = this.baseUrl + "/api/Software/UpdateToLatestVersion?";
        if (deviceId !== undefined)
            url_ += "DeviceId=" + encodeURIComponent("" + deviceId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateToLatestVersion(_response);
        });
    }

    protected processUpdateToLatestVersion(response: AxiosResponse): Promise<UpdateToLatestVersionResponse> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateToLatestVersionResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateToLatestVersionResponse>(<any>null);
    }

    /**
     * @param version (optional) 
     * @param deviceId (optional) 
     * @return Success
     */
    updateToSpecificVersion(version: string | null | undefined, deviceId: string | null | undefined): Promise<UpdateToSpecificVersionResponse> {
        let url_ = this.baseUrl + "/api/Software/UpdateToSpecificVersion?";
        if (version !== undefined)
            url_ += "Version=" + encodeURIComponent("" + version) + "&"; 
        if (deviceId !== undefined)
            url_ += "DeviceId=" + encodeURIComponent("" + deviceId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateToSpecificVersion(_response);
        });
    }

    protected processUpdateToSpecificVersion(response: AxiosResponse): Promise<UpdateToSpecificVersionResponse> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateToSpecificVersionResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateToSpecificVersionResponse>(<any>null);
    }

    /**
     * @param deviceId (optional) 
     * @return Success
     */
    getAllVersions(deviceId: string | null | undefined): Promise<GetAllVersionsResponse> {
        let url_ = this.baseUrl + "/api/Software/GetAllVersions?";
        if (deviceId !== undefined)
            url_ += "DeviceId=" + encodeURIComponent("" + deviceId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAllVersions(_response);
        });
    }

    protected processGetAllVersions(response: AxiosResponse): Promise<GetAllVersionsResponse> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllVersionsResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllVersionsResponse>(<any>null);
    }

    /**
     * @return Success
     */
    test(): Promise<MyNmea2kMessage> {
        let url_ = this.baseUrl + "/api/Test/Test";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processTest(_response);
        });
    }

    protected processTest(response: AxiosResponse): Promise<MyNmea2kMessage> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MyNmea2kMessage.fromJS(resultData200);
            return result200;
        } else if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = MyTestMessage.fromJS(resultData201);
            return throwException("A server error occurred.", status, _responseText, _headers, result201);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MyNmea2kMessage>(<any>null);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    loggedOut(request: any | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/User/LoggedOut?";
        if (request !== undefined)
            url_ += "request=" + encodeURIComponent("" + request) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processLoggedOut(_response);
        });
    }

    protected processLoggedOut(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param deviceId (optional) 
     * @return Success
     */
    getWifiStations(deviceId: string | null | undefined): Promise<GetWifiStationsResponse> {
        let url_ = this.baseUrl + "/api/Wifi/GetWifiStations?";
        if (deviceId !== undefined)
            url_ += "DeviceId=" + encodeURIComponent("" + deviceId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetWifiStations(_response);
        });
    }

    protected processGetWifiStations(response: AxiosResponse): Promise<GetWifiStationsResponse> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetWifiStationsResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetWifiStationsResponse>(<any>null);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    connectToWifiStation(request: ConnectToWifiStationRequest | null | undefined): Promise<ConnectToWifiStationResponse> {
        let url_ = this.baseUrl + "/api/Wifi/ConnectToWifiStation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processConnectToWifiStation(_response);
        });
    }

    protected processConnectToWifiStation(response: AxiosResponse): Promise<ConnectToWifiStationResponse> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ConnectToWifiStationResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConnectToWifiStationResponse>(<any>null);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    disconnectFromWifiStation(request: DisconnectFromWifiStationRequest | null | undefined): Promise<DisconnectFromWifiStationResponse> {
        let url_ = this.baseUrl + "/api/Wifi/DisconnectFromWifiStation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDisconnectFromWifiStation(_response);
        });
    }

    protected processDisconnectFromWifiStation(response: AxiosResponse): Promise<DisconnectFromWifiStationResponse> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DisconnectFromWifiStationResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DisconnectFromWifiStationResponse>(<any>null);
    }
}

export class GetDeviceInfoResponse implements IGetDeviceInfoResponse {
    readonly extraInfo?: { [key: string] : string; } | undefined;
    wiFiIdentifier?: string | undefined;
    wifiIp?: string | undefined;
    upTime?: string | undefined;
    bootCounter?: number | undefined;
    firmwareVersion?: string | undefined;
    hardwareVersion?: string | undefined;
    deviceNumber?: string | undefined;
    deviceOwner?: number | undefined;
    freeMemory?: string | undefined;
    connections?: string | undefined;
    macAddress?: string | undefined;

    constructor(data?: IGetDeviceInfoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["extraInfo"]) {
                (<any>this).extraInfo = {} as any;
                for (let key in data["extraInfo"]) {
                    if (data["extraInfo"].hasOwnProperty(key))
                        (<any>this).extraInfo![key] = data["extraInfo"][key];
                }
            }
            this.wiFiIdentifier = data["wiFiIdentifier"];
            this.wifiIp = data["wifiIp"];
            this.upTime = data["upTime"];
            this.bootCounter = data["bootCounter"];
            this.firmwareVersion = data["firmwareVersion"];
            this.hardwareVersion = data["hardwareVersion"];
            this.deviceNumber = data["deviceNumber"];
            this.deviceOwner = data["deviceOwner"];
            this.freeMemory = data["freeMemory"];
            this.connections = data["connections"];
            this.macAddress = data["macAddress"];
        }
    }

    static fromJS(data: any): GetDeviceInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDeviceInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.extraInfo) {
            data["extraInfo"] = {};
            for (let key in this.extraInfo) {
                if (this.extraInfo.hasOwnProperty(key))
                    data["extraInfo"][key] = this.extraInfo[key];
            }
        }
        data["wiFiIdentifier"] = this.wiFiIdentifier;
        data["wifiIp"] = this.wifiIp;
        data["upTime"] = this.upTime;
        data["bootCounter"] = this.bootCounter;
        data["firmwareVersion"] = this.firmwareVersion;
        data["hardwareVersion"] = this.hardwareVersion;
        data["deviceNumber"] = this.deviceNumber;
        data["deviceOwner"] = this.deviceOwner;
        data["freeMemory"] = this.freeMemory;
        data["connections"] = this.connections;
        data["macAddress"] = this.macAddress;
        return data; 
    }
}

export interface IGetDeviceInfoResponse {
    extraInfo?: { [key: string] : string; } | undefined;
    wiFiIdentifier?: string | undefined;
    wifiIp?: string | undefined;
    upTime?: string | undefined;
    bootCounter?: number | undefined;
    firmwareVersion?: string | undefined;
    hardwareVersion?: string | undefined;
    deviceNumber?: string | undefined;
    deviceOwner?: number | undefined;
    freeMemory?: string | undefined;
    connections?: string | undefined;
    macAddress?: string | undefined;
}

export class GetDevicesRequest implements IGetDevicesRequest {

    constructor(data?: IGetDevicesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
    }

    static fromJS(data: any): GetDevicesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDevicesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }
}

export interface IGetDevicesRequest {
}

export class GetDevicesResponse implements IGetDevicesResponse {
    readonly devices?: DeviceInfo[] | undefined;

    constructor(data?: IGetDevicesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["devices"])) {
                (<any>this).devices = [] as any;
                for (let item of data["devices"])
                    (<any>this).devices!.push(DeviceInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDevicesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDevicesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.devices)) {
            data["devices"] = [];
            for (let item of this.devices)
                data["devices"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetDevicesResponse {
    devices?: DeviceInfo[] | undefined;
}

export class DeviceInfo implements IDeviceInfo {
    readonly number?: string | undefined;
    name?: string | undefined;
    readonly firmwareVersion?: string | undefined;
    readonly owner?: number | undefined;
    readonly connections?: ConnectionInfo[] | undefined;

    constructor(data?: IDeviceInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            (<any>this).number = data["number"];
            this.name = data["name"];
            (<any>this).firmwareVersion = data["firmwareVersion"];
            (<any>this).owner = data["owner"];
            if (Array.isArray(data["connections"])) {
                (<any>this).connections = [] as any;
                for (let item of data["connections"])
                    (<any>this).connections!.push(ConnectionInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DeviceInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["name"] = this.name;
        data["firmwareVersion"] = this.firmwareVersion;
        data["owner"] = this.owner;
        if (Array.isArray(this.connections)) {
            data["connections"] = [];
            for (let item of this.connections)
                data["connections"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDeviceInfo {
    number?: string | undefined;
    name?: string | undefined;
    firmwareVersion?: string | undefined;
    owner?: number | undefined;
    connections?: ConnectionInfo[] | undefined;
}

export class ConnectionInfo implements IConnectionInfo {
    connectionType?: string | undefined;
    readonly online?: boolean | undefined;
    readonly lastSeen?: Date | undefined;
    readonly signalStrength1To5?: number | undefined;

    constructor(data?: IConnectionInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.connectionType = data["connectionType"];
            (<any>this).online = data["online"];
            (<any>this).lastSeen = data["lastSeen"] ? new Date(data["lastSeen"].toString()) : <any>undefined;
            (<any>this).signalStrength1To5 = data["signalStrength1To5"];
        }
    }

    static fromJS(data: any): ConnectionInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectionInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectionType"] = this.connectionType;
        data["online"] = this.online;
        data["lastSeen"] = this.lastSeen ? this.lastSeen.toISOString() : <any>undefined;
        data["signalStrength1To5"] = this.signalStrength1To5;
        return data; 
    }
}

export interface IConnectionInfo {
    connectionType?: string | undefined;
    online?: boolean | undefined;
    lastSeen?: Date | undefined;
    signalStrength1To5?: number | undefined;
}

export class SetDeviceNameResponse implements ISetDeviceNameResponse {

    constructor(data?: ISetDeviceNameResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
    }

    static fromJS(data: any): SetDeviceNameResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetDeviceNameResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }
}

export interface ISetDeviceNameResponse {
}

export class RestartDeviceResponse implements IRestartDeviceResponse {

    constructor(data?: IRestartDeviceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
    }

    static fromJS(data: any): RestartDeviceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RestartDeviceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }
}

export interface IRestartDeviceResponse {
}

export class ResetDeviceRequest implements IResetDeviceRequest {
    deviceId?: string | undefined;

    constructor(data?: IResetDeviceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deviceId = data["deviceId"];
        }
    }

    static fromJS(data: any): ResetDeviceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResetDeviceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        return data; 
    }
}

export interface IResetDeviceRequest {
    deviceId?: string | undefined;
}

export class ResetDeviceResponse implements IResetDeviceResponse {

    constructor(data?: IResetDeviceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
    }

    static fromJS(data: any): ResetDeviceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResetDeviceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }
}

export interface IResetDeviceResponse {
}

export class PairDeviceResponse implements IPairDeviceResponse {

    constructor(data?: IPairDeviceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
    }

    static fromJS(data: any): PairDeviceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PairDeviceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }
}

export interface IPairDeviceResponse {
}

export class AllEvents implements IAllEvents {
    readonly relaysChanged?: RelaysChangedEvent | undefined;
    readonly fileTransferProgress?: FileTransferProgressEvent | undefined;
    readonly fluidLevel?: N2KFluidLevelEvent | undefined;
    readonly gnss?: N2KGnssEvent | undefined;
    readonly heading?: N2KHeadingEvent | undefined;
    readonly rudder?: N2KRudderEvent | undefined;
    readonly speed?: N2KSpeedEvent | undefined;
    readonly temperature?: N2KTemperatureEvent | undefined;
    readonly waterDepth?: N2KWaterDepthEvent | undefined;
    readonly wind?: N2KWindEvent | undefined;
    readonly n2KTemperature?: N2KTemperatureEvent | undefined;
    readonly deviceChangedEvent?: DeviceChangedEvent | undefined;
    readonly outsideEnvironmentalEvent?: N2KOutsideEnvironmentalEvent | undefined;

    constructor(data?: IAllEvents) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            (<any>this).relaysChanged = data["relaysChanged"] ? RelaysChangedEvent.fromJS(data["relaysChanged"]) : <any>undefined;
            (<any>this).fileTransferProgress = data["fileTransferProgress"] ? FileTransferProgressEvent.fromJS(data["fileTransferProgress"]) : <any>undefined;
            (<any>this).fluidLevel = data["fluidLevel"] ? N2KFluidLevelEvent.fromJS(data["fluidLevel"]) : <any>undefined;
            (<any>this).gnss = data["gnss"] ? N2KGnssEvent.fromJS(data["gnss"]) : <any>undefined;
            (<any>this).heading = data["heading"] ? N2KHeadingEvent.fromJS(data["heading"]) : <any>undefined;
            (<any>this).rudder = data["rudder"] ? N2KRudderEvent.fromJS(data["rudder"]) : <any>undefined;
            (<any>this).speed = data["speed"] ? N2KSpeedEvent.fromJS(data["speed"]) : <any>undefined;
            (<any>this).temperature = data["temperature"] ? N2KTemperatureEvent.fromJS(data["temperature"]) : <any>undefined;
            (<any>this).waterDepth = data["waterDepth"] ? N2KWaterDepthEvent.fromJS(data["waterDepth"]) : <any>undefined;
            (<any>this).wind = data["wind"] ? N2KWindEvent.fromJS(data["wind"]) : <any>undefined;
            (<any>this).n2KTemperature = data["n2KTemperature"] ? N2KTemperatureEvent.fromJS(data["n2KTemperature"]) : <any>undefined;
            (<any>this).deviceChangedEvent = data["deviceChangedEvent"] ? DeviceChangedEvent.fromJS(data["deviceChangedEvent"]) : <any>undefined;
            (<any>this).outsideEnvironmentalEvent = data["outsideEnvironmentalEvent"] ? N2KOutsideEnvironmentalEvent.fromJS(data["outsideEnvironmentalEvent"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AllEvents {
        data = typeof data === 'object' ? data : {};
        let result = new AllEvents();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["relaysChanged"] = this.relaysChanged ? this.relaysChanged.toJSON() : <any>undefined;
        data["fileTransferProgress"] = this.fileTransferProgress ? this.fileTransferProgress.toJSON() : <any>undefined;
        data["fluidLevel"] = this.fluidLevel ? this.fluidLevel.toJSON() : <any>undefined;
        data["gnss"] = this.gnss ? this.gnss.toJSON() : <any>undefined;
        data["heading"] = this.heading ? this.heading.toJSON() : <any>undefined;
        data["rudder"] = this.rudder ? this.rudder.toJSON() : <any>undefined;
        data["speed"] = this.speed ? this.speed.toJSON() : <any>undefined;
        data["temperature"] = this.temperature ? this.temperature.toJSON() : <any>undefined;
        data["waterDepth"] = this.waterDepth ? this.waterDepth.toJSON() : <any>undefined;
        data["wind"] = this.wind ? this.wind.toJSON() : <any>undefined;
        data["n2KTemperature"] = this.n2KTemperature ? this.n2KTemperature.toJSON() : <any>undefined;
        data["deviceChangedEvent"] = this.deviceChangedEvent ? this.deviceChangedEvent.toJSON() : <any>undefined;
        data["outsideEnvironmentalEvent"] = this.outsideEnvironmentalEvent ? this.outsideEnvironmentalEvent.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAllEvents {
    relaysChanged?: RelaysChangedEvent | undefined;
    fileTransferProgress?: FileTransferProgressEvent | undefined;
    fluidLevel?: N2KFluidLevelEvent | undefined;
    gnss?: N2KGnssEvent | undefined;
    heading?: N2KHeadingEvent | undefined;
    rudder?: N2KRudderEvent | undefined;
    speed?: N2KSpeedEvent | undefined;
    temperature?: N2KTemperatureEvent | undefined;
    waterDepth?: N2KWaterDepthEvent | undefined;
    wind?: N2KWindEvent | undefined;
    n2KTemperature?: N2KTemperatureEvent | undefined;
    deviceChangedEvent?: DeviceChangedEvent | undefined;
    outsideEnvironmentalEvent?: N2KOutsideEnvironmentalEvent | undefined;
}

export class RelaysChangedEvent implements IRelaysChangedEvent {
    readonly relays?: boolean[] | undefined;
    readonly deviceNumber?: string | undefined;
    readonly timestamp?: Date | undefined;

    constructor(data?: IRelaysChangedEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["relays"])) {
                (<any>this).relays = [] as any;
                for (let item of data["relays"])
                    (<any>this).relays!.push(item);
            }
            (<any>this).deviceNumber = data["deviceNumber"];
            (<any>this).timestamp = data["timestamp"] ? new Date(data["timestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RelaysChangedEvent {
        data = typeof data === 'object' ? data : {};
        let result = new RelaysChangedEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.relays)) {
            data["relays"] = [];
            for (let item of this.relays)
                data["relays"].push(item);
        }
        data["deviceNumber"] = this.deviceNumber;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IRelaysChangedEvent {
    relays?: boolean[] | undefined;
    deviceNumber?: string | undefined;
    timestamp?: Date | undefined;
}

export class FileTransferProgressEvent implements IFileTransferProgressEvent {
    readonly outgoing?: boolean | undefined;
    readonly bytesTransferred?: number | undefined;
    readonly bytesTotal?: number | undefined;
    readonly deviceNumber?: string | undefined;
    readonly timestamp?: Date | undefined;

    constructor(data?: IFileTransferProgressEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            (<any>this).outgoing = data["outgoing"];
            (<any>this).bytesTransferred = data["bytesTransferred"];
            (<any>this).bytesTotal = data["bytesTotal"];
            (<any>this).deviceNumber = data["deviceNumber"];
            (<any>this).timestamp = data["timestamp"] ? new Date(data["timestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FileTransferProgressEvent {
        data = typeof data === 'object' ? data : {};
        let result = new FileTransferProgressEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outgoing"] = this.outgoing;
        data["bytesTransferred"] = this.bytesTransferred;
        data["bytesTotal"] = this.bytesTotal;
        data["deviceNumber"] = this.deviceNumber;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IFileTransferProgressEvent {
    outgoing?: boolean | undefined;
    bytesTransferred?: number | undefined;
    bytesTotal?: number | undefined;
    deviceNumber?: string | undefined;
    timestamp?: Date | undefined;
}

export class N2KFluidLevelEvent implements IN2KFluidLevelEvent {
    readonly type?: N2KFluidLevelEventType | undefined;
    readonly level?: number | undefined;
    readonly capacity?: number | undefined;
    readonly sensorNumber?: number | undefined;
    readonly deviceNumber?: string | undefined;
    readonly timestamp?: Date | undefined;

    constructor(data?: IN2KFluidLevelEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            (<any>this).type = data["type"];
            (<any>this).level = data["level"];
            (<any>this).capacity = data["capacity"];
            (<any>this).sensorNumber = data["sensorNumber"];
            (<any>this).deviceNumber = data["deviceNumber"];
            (<any>this).timestamp = data["timestamp"] ? new Date(data["timestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): N2KFluidLevelEvent {
        data = typeof data === 'object' ? data : {};
        let result = new N2KFluidLevelEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["level"] = this.level;
        data["capacity"] = this.capacity;
        data["sensorNumber"] = this.sensorNumber;
        data["deviceNumber"] = this.deviceNumber;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IN2KFluidLevelEvent {
    type?: N2KFluidLevelEventType | undefined;
    level?: number | undefined;
    capacity?: number | undefined;
    sensorNumber?: number | undefined;
    deviceNumber?: string | undefined;
    timestamp?: Date | undefined;
}

export class N2KGnssEvent implements IN2KGnssEvent {
    readonly latitude?: number | undefined;
    readonly longitude?: number | undefined;
    readonly altitude?: number | undefined;
    readonly type?: N2KGnssEventType | undefined;
    readonly method?: N2KGnssEventMethod | undefined;
    readonly sattelites?: number | undefined;
    readonly hdop?: number | undefined;
    readonly pdop?: number | undefined;
    readonly sensorNumber?: number | undefined;
    readonly deviceNumber?: string | undefined;
    readonly timestamp?: Date | undefined;

    constructor(data?: IN2KGnssEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            (<any>this).latitude = data["latitude"];
            (<any>this).longitude = data["longitude"];
            (<any>this).altitude = data["altitude"];
            (<any>this).type = data["type"];
            (<any>this).method = data["method"];
            (<any>this).sattelites = data["sattelites"];
            (<any>this).hdop = data["hdop"];
            (<any>this).pdop = data["pdop"];
            (<any>this).sensorNumber = data["sensorNumber"];
            (<any>this).deviceNumber = data["deviceNumber"];
            (<any>this).timestamp = data["timestamp"] ? new Date(data["timestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): N2KGnssEvent {
        data = typeof data === 'object' ? data : {};
        let result = new N2KGnssEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["altitude"] = this.altitude;
        data["type"] = this.type;
        data["method"] = this.method;
        data["sattelites"] = this.sattelites;
        data["hdop"] = this.hdop;
        data["pdop"] = this.pdop;
        data["sensorNumber"] = this.sensorNumber;
        data["deviceNumber"] = this.deviceNumber;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IN2KGnssEvent {
    latitude?: number | undefined;
    longitude?: number | undefined;
    altitude?: number | undefined;
    type?: N2KGnssEventType | undefined;
    method?: N2KGnssEventMethod | undefined;
    sattelites?: number | undefined;
    hdop?: number | undefined;
    pdop?: number | undefined;
    sensorNumber?: number | undefined;
    deviceNumber?: string | undefined;
    timestamp?: Date | undefined;
}

export class N2KHeadingEvent implements IN2KHeadingEvent {
    readonly reference?: N2KHeadingEventReference | undefined;
    readonly heading?: number | undefined;
    readonly deviation?: number | undefined;
    readonly variation?: number | undefined;
    readonly sensorNumber?: number | undefined;
    readonly deviceNumber?: string | undefined;
    readonly timestamp?: Date | undefined;

    constructor(data?: IN2KHeadingEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            (<any>this).reference = data["reference"];
            (<any>this).heading = data["heading"];
            (<any>this).deviation = data["deviation"];
            (<any>this).variation = data["variation"];
            (<any>this).sensorNumber = data["sensorNumber"];
            (<any>this).deviceNumber = data["deviceNumber"];
            (<any>this).timestamp = data["timestamp"] ? new Date(data["timestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): N2KHeadingEvent {
        data = typeof data === 'object' ? data : {};
        let result = new N2KHeadingEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reference"] = this.reference;
        data["heading"] = this.heading;
        data["deviation"] = this.deviation;
        data["variation"] = this.variation;
        data["sensorNumber"] = this.sensorNumber;
        data["deviceNumber"] = this.deviceNumber;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IN2KHeadingEvent {
    reference?: N2KHeadingEventReference | undefined;
    heading?: number | undefined;
    deviation?: number | undefined;
    variation?: number | undefined;
    sensorNumber?: number | undefined;
    deviceNumber?: string | undefined;
    timestamp?: Date | undefined;
}

export class N2KRudderEvent implements IN2KRudderEvent {
    readonly directionOrder?: N2KRudderEventDirectionOrder | undefined;
    readonly instance?: number | undefined;
    readonly position?: number | undefined;
    readonly angleOrder?: number | undefined;
    readonly sensorNumber?: number | undefined;
    readonly deviceNumber?: string | undefined;
    readonly timestamp?: Date | undefined;

    constructor(data?: IN2KRudderEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            (<any>this).directionOrder = data["directionOrder"];
            (<any>this).instance = data["instance"];
            (<any>this).position = data["position"];
            (<any>this).angleOrder = data["angleOrder"];
            (<any>this).sensorNumber = data["sensorNumber"];
            (<any>this).deviceNumber = data["deviceNumber"];
            (<any>this).timestamp = data["timestamp"] ? new Date(data["timestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): N2KRudderEvent {
        data = typeof data === 'object' ? data : {};
        let result = new N2KRudderEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["directionOrder"] = this.directionOrder;
        data["instance"] = this.instance;
        data["position"] = this.position;
        data["angleOrder"] = this.angleOrder;
        data["sensorNumber"] = this.sensorNumber;
        data["deviceNumber"] = this.deviceNumber;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IN2KRudderEvent {
    directionOrder?: N2KRudderEventDirectionOrder | undefined;
    instance?: number | undefined;
    position?: number | undefined;
    angleOrder?: number | undefined;
    sensorNumber?: number | undefined;
    deviceNumber?: string | undefined;
    timestamp?: Date | undefined;
}

export class N2KSpeedEvent implements IN2KSpeedEvent {
    readonly reference?: N2KSpeedEventReference | undefined;
    readonly speedOverWater?: number | undefined;
    readonly speedOverGround?: number | undefined;
    readonly sensorNumber?: number | undefined;
    readonly deviceNumber?: string | undefined;
    readonly timestamp?: Date | undefined;

    constructor(data?: IN2KSpeedEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            (<any>this).reference = data["reference"];
            (<any>this).speedOverWater = data["speedOverWater"];
            (<any>this).speedOverGround = data["speedOverGround"];
            (<any>this).sensorNumber = data["sensorNumber"];
            (<any>this).deviceNumber = data["deviceNumber"];
            (<any>this).timestamp = data["timestamp"] ? new Date(data["timestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): N2KSpeedEvent {
        data = typeof data === 'object' ? data : {};
        let result = new N2KSpeedEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reference"] = this.reference;
        data["speedOverWater"] = this.speedOverWater;
        data["speedOverGround"] = this.speedOverGround;
        data["sensorNumber"] = this.sensorNumber;
        data["deviceNumber"] = this.deviceNumber;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IN2KSpeedEvent {
    reference?: N2KSpeedEventReference | undefined;
    speedOverWater?: number | undefined;
    speedOverGround?: number | undefined;
    sensorNumber?: number | undefined;
    deviceNumber?: string | undefined;
    timestamp?: Date | undefined;
}

export class N2KTemperatureEvent implements IN2KTemperatureEvent {
    readonly source?: N2KTemperatureEventSource | undefined;
    readonly temperature?: number | undefined;
    readonly setTemperature?: number | undefined;
    readonly sensorNumber?: number | undefined;
    readonly deviceNumber?: string | undefined;
    readonly timestamp?: Date | undefined;

    constructor(data?: IN2KTemperatureEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            (<any>this).source = data["source"];
            (<any>this).temperature = data["temperature"];
            (<any>this).setTemperature = data["setTemperature"];
            (<any>this).sensorNumber = data["sensorNumber"];
            (<any>this).deviceNumber = data["deviceNumber"];
            (<any>this).timestamp = data["timestamp"] ? new Date(data["timestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): N2KTemperatureEvent {
        data = typeof data === 'object' ? data : {};
        let result = new N2KTemperatureEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source;
        data["temperature"] = this.temperature;
        data["setTemperature"] = this.setTemperature;
        data["sensorNumber"] = this.sensorNumber;
        data["deviceNumber"] = this.deviceNumber;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IN2KTemperatureEvent {
    source?: N2KTemperatureEventSource | undefined;
    temperature?: number | undefined;
    setTemperature?: number | undefined;
    sensorNumber?: number | undefined;
    deviceNumber?: string | undefined;
    timestamp?: Date | undefined;
}

export class N2KWaterDepthEvent implements IN2KWaterDepthEvent {
    readonly depth?: number | undefined;
    readonly offset?: number | undefined;
    readonly sensorNumber?: number | undefined;
    readonly deviceNumber?: string | undefined;
    readonly timestamp?: Date | undefined;

    constructor(data?: IN2KWaterDepthEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            (<any>this).depth = data["depth"];
            (<any>this).offset = data["offset"];
            (<any>this).sensorNumber = data["sensorNumber"];
            (<any>this).deviceNumber = data["deviceNumber"];
            (<any>this).timestamp = data["timestamp"] ? new Date(data["timestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): N2KWaterDepthEvent {
        data = typeof data === 'object' ? data : {};
        let result = new N2KWaterDepthEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["depth"] = this.depth;
        data["offset"] = this.offset;
        data["sensorNumber"] = this.sensorNumber;
        data["deviceNumber"] = this.deviceNumber;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IN2KWaterDepthEvent {
    depth?: number | undefined;
    offset?: number | undefined;
    sensorNumber?: number | undefined;
    deviceNumber?: string | undefined;
    timestamp?: Date | undefined;
}

export class N2KWindEvent implements IN2KWindEvent {
    speed?: number | undefined;
    angle?: number | undefined;
    reference?: N2KWindEventReference | undefined;
    readonly sensorNumber?: number | undefined;
    readonly deviceNumber?: string | undefined;
    readonly timestamp?: Date | undefined;

    constructor(data?: IN2KWindEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.speed = data["speed"];
            this.angle = data["angle"];
            this.reference = data["reference"];
            (<any>this).sensorNumber = data["sensorNumber"];
            (<any>this).deviceNumber = data["deviceNumber"];
            (<any>this).timestamp = data["timestamp"] ? new Date(data["timestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): N2KWindEvent {
        data = typeof data === 'object' ? data : {};
        let result = new N2KWindEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["speed"] = this.speed;
        data["angle"] = this.angle;
        data["reference"] = this.reference;
        data["sensorNumber"] = this.sensorNumber;
        data["deviceNumber"] = this.deviceNumber;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IN2KWindEvent {
    speed?: number | undefined;
    angle?: number | undefined;
    reference?: N2KWindEventReference | undefined;
    sensorNumber?: number | undefined;
    deviceNumber?: string | undefined;
    timestamp?: Date | undefined;
}

export class DeviceChangedEvent implements IDeviceChangedEvent {
    readonly deviceInfo?: DeviceInfo | undefined;
    readonly deviceNumber?: string | undefined;
    readonly timestamp?: Date | undefined;

    constructor(data?: IDeviceChangedEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            (<any>this).deviceInfo = data["deviceInfo"] ? DeviceInfo.fromJS(data["deviceInfo"]) : <any>undefined;
            (<any>this).deviceNumber = data["deviceNumber"];
            (<any>this).timestamp = data["timestamp"] ? new Date(data["timestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DeviceChangedEvent {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceChangedEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceInfo"] = this.deviceInfo ? this.deviceInfo.toJSON() : <any>undefined;
        data["deviceNumber"] = this.deviceNumber;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IDeviceChangedEvent {
    deviceInfo?: DeviceInfo | undefined;
    deviceNumber?: string | undefined;
    timestamp?: Date | undefined;
}

export class N2KOutsideEnvironmentalEvent implements IN2KOutsideEnvironmentalEvent {
    readonly waterTemperature?: number | undefined;
    readonly outsideAmbientAirTemperature?: number | undefined;
    readonly atmosphericPressure?: number | undefined;
    readonly sensorNumber?: number | undefined;
    readonly deviceNumber?: string | undefined;
    readonly timestamp?: Date | undefined;

    constructor(data?: IN2KOutsideEnvironmentalEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            (<any>this).waterTemperature = data["waterTemperature"];
            (<any>this).outsideAmbientAirTemperature = data["outsideAmbientAirTemperature"];
            (<any>this).atmosphericPressure = data["atmosphericPressure"];
            (<any>this).sensorNumber = data["sensorNumber"];
            (<any>this).deviceNumber = data["deviceNumber"];
            (<any>this).timestamp = data["timestamp"] ? new Date(data["timestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): N2KOutsideEnvironmentalEvent {
        data = typeof data === 'object' ? data : {};
        let result = new N2KOutsideEnvironmentalEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["waterTemperature"] = this.waterTemperature;
        data["outsideAmbientAirTemperature"] = this.outsideAmbientAirTemperature;
        data["atmosphericPressure"] = this.atmosphericPressure;
        data["sensorNumber"] = this.sensorNumber;
        data["deviceNumber"] = this.deviceNumber;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IN2KOutsideEnvironmentalEvent {
    waterTemperature?: number | undefined;
    outsideAmbientAirTemperature?: number | undefined;
    atmosphericPressure?: number | undefined;
    sensorNumber?: number | undefined;
    deviceNumber?: string | undefined;
    timestamp?: Date | undefined;
}

export class StartCameraResponse implements IStartCameraResponse {

    constructor(data?: IStartCameraResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
    }

    static fromJS(data: any): StartCameraResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StartCameraResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }
}

export interface IStartCameraResponse {
}

export class GetFileAsJsonResponse implements IGetFileAsJsonResponse {
    content?: any | undefined;

    constructor(data?: IGetFileAsJsonResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.content = data["content"];
        }
    }

    static fromJS(data: any): GetFileAsJsonResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFileAsJsonResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content;
        return data; 
    }
}

export interface IGetFileAsJsonResponse {
    content?: any | undefined;
}

export class GetFileAsBytesResponse implements IGetFileAsBytesResponse {
    content?: string | undefined;

    constructor(data?: IGetFileAsBytesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.content = data["content"];
        }
    }

    static fromJS(data: any): GetFileAsBytesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFileAsBytesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content;
        return data; 
    }
}

export interface IGetFileAsBytesResponse {
    content?: string | undefined;
}

export class UploadFileAsJsonRequest implements IUploadFileAsJsonRequest {
    filename?: string | undefined;
    content?: any | undefined;
    deviceId?: string | undefined;

    constructor(data?: IUploadFileAsJsonRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filename = data["filename"];
            this.content = data["content"];
            this.deviceId = data["deviceId"];
        }
    }

    static fromJS(data: any): UploadFileAsJsonRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UploadFileAsJsonRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filename"] = this.filename;
        data["content"] = this.content;
        data["deviceId"] = this.deviceId;
        return data; 
    }
}

export interface IUploadFileAsJsonRequest {
    filename?: string | undefined;
    content?: any | undefined;
    deviceId?: string | undefined;
}

export class UploadFileAsJsonResponse implements IUploadFileAsJsonResponse {

    constructor(data?: IUploadFileAsJsonResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
    }

    static fromJS(data: any): UploadFileAsJsonResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UploadFileAsJsonResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }
}

export interface IUploadFileAsJsonResponse {
}

export class UploadFileAsBytesRequest implements IUploadFileAsBytesRequest {
    filename?: string | undefined;
    content?: string | undefined;
    deviceId?: string | undefined;

    constructor(data?: IUploadFileAsBytesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filename = data["filename"];
            this.content = data["content"];
            this.deviceId = data["deviceId"];
        }
    }

    static fromJS(data: any): UploadFileAsBytesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UploadFileAsBytesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filename"] = this.filename;
        data["content"] = this.content;
        data["deviceId"] = this.deviceId;
        return data; 
    }
}

export interface IUploadFileAsBytesRequest {
    filename?: string | undefined;
    content?: string | undefined;
    deviceId?: string | undefined;
}

export class UploadFileAsBytesResponse implements IUploadFileAsBytesResponse {

    constructor(data?: IUploadFileAsBytesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
    }

    static fromJS(data: any): UploadFileAsBytesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UploadFileAsBytesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }
}

export interface IUploadFileAsBytesResponse {
}

export class SetRelayRequest implements ISetRelayRequest {
    relayNumber?: number | undefined;
    turnOn?: boolean | undefined;
    turnOfAfterMs?: number | undefined;
    deviceId?: string | undefined;

    constructor(data?: ISetRelayRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.relayNumber = data["relayNumber"];
            this.turnOn = data["turnOn"];
            this.turnOfAfterMs = data["turnOfAfterMs"];
            this.deviceId = data["deviceId"];
        }
    }

    static fromJS(data: any): SetRelayRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetRelayRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["relayNumber"] = this.relayNumber;
        data["turnOn"] = this.turnOn;
        data["turnOfAfterMs"] = this.turnOfAfterMs;
        data["deviceId"] = this.deviceId;
        return data; 
    }
}

export interface ISetRelayRequest {
    relayNumber?: number | undefined;
    turnOn?: boolean | undefined;
    turnOfAfterMs?: number | undefined;
    deviceId?: string | undefined;
}

export class SetRelayResponse implements ISetRelayResponse {
    readonly relays?: boolean[] | undefined;

    constructor(data?: ISetRelayResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["relays"])) {
                (<any>this).relays = [] as any;
                for (let item of data["relays"])
                    (<any>this).relays!.push(item);
            }
        }
    }

    static fromJS(data: any): SetRelayResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetRelayResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.relays)) {
            data["relays"] = [];
            for (let item of this.relays)
                data["relays"].push(item);
        }
        return data; 
    }
}

export interface ISetRelayResponse {
    relays?: boolean[] | undefined;
}

export class GetRelaysResponse implements IGetRelaysResponse {
    readonly relays?: boolean[] | undefined;

    constructor(data?: IGetRelaysResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["relays"])) {
                (<any>this).relays = [] as any;
                for (let item of data["relays"])
                    (<any>this).relays!.push(item);
            }
        }
    }

    static fromJS(data: any): GetRelaysResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRelaysResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.relays)) {
            data["relays"] = [];
            for (let item of this.relays)
                data["relays"].push(item);
        }
        return data; 
    }
}

export interface IGetRelaysResponse {
    relays?: boolean[] | undefined;
}

export class GetFirmwareInfoResponse implements IGetFirmwareInfoResponse {
    readonly currentVersion?: string | undefined;
    readonly latestVersion?: string | undefined;
    readonly releaseNotes?: string | undefined;

    constructor(data?: IGetFirmwareInfoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            (<any>this).currentVersion = data["currentVersion"];
            (<any>this).latestVersion = data["latestVersion"];
            (<any>this).releaseNotes = data["releaseNotes"];
        }
    }

    static fromJS(data: any): GetFirmwareInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFirmwareInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentVersion"] = this.currentVersion;
        data["latestVersion"] = this.latestVersion;
        data["releaseNotes"] = this.releaseNotes;
        return data; 
    }
}

export interface IGetFirmwareInfoResponse {
    currentVersion?: string | undefined;
    latestVersion?: string | undefined;
    releaseNotes?: string | undefined;
}

export class UpdateToLatestVersionResponse implements IUpdateToLatestVersionResponse {

    constructor(data?: IUpdateToLatestVersionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
    }

    static fromJS(data: any): UpdateToLatestVersionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateToLatestVersionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }
}

export interface IUpdateToLatestVersionResponse {
}

export class UpdateToSpecificVersionResponse implements IUpdateToSpecificVersionResponse {

    constructor(data?: IUpdateToSpecificVersionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
    }

    static fromJS(data: any): UpdateToSpecificVersionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateToSpecificVersionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }
}

export interface IUpdateToSpecificVersionResponse {
}

export class GetAllVersionsResponse implements IGetAllVersionsResponse {
    readonly versions?: SoftwareVersion[] | undefined;
    current?: SoftwareVersion | undefined;

    constructor(data?: IGetAllVersionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["versions"])) {
                (<any>this).versions = [] as any;
                for (let item of data["versions"])
                    (<any>this).versions!.push(SoftwareVersion.fromJS(item));
            }
            this.current = data["current"] ? SoftwareVersion.fromJS(data["current"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAllVersionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllVersionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.versions)) {
            data["versions"] = [];
            for (let item of this.versions)
                data["versions"].push(item.toJSON());
        }
        data["current"] = this.current ? this.current.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetAllVersionsResponse {
    versions?: SoftwareVersion[] | undefined;
    current?: SoftwareVersion | undefined;
}

export class SoftwareVersion implements ISoftwareVersion {
    readonly createdAt?: Date | undefined;
    readonly version?: string | undefined;
    readonly releaseGroups?: number[] | undefined;

    constructor(data?: ISoftwareVersion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            (<any>this).createdAt = data["createdAt"] ? new Date(data["createdAt"].toString()) : <any>undefined;
            (<any>this).version = data["version"];
            if (Array.isArray(data["releaseGroups"])) {
                (<any>this).releaseGroups = [] as any;
                for (let item of data["releaseGroups"])
                    (<any>this).releaseGroups!.push(item);
            }
        }
    }

    static fromJS(data: any): SoftwareVersion {
        data = typeof data === 'object' ? data : {};
        let result = new SoftwareVersion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["version"] = this.version;
        if (Array.isArray(this.releaseGroups)) {
            data["releaseGroups"] = [];
            for (let item of this.releaseGroups)
                data["releaseGroups"].push(item);
        }
        return data; 
    }
}

export interface ISoftwareVersion {
    createdAt?: Date | undefined;
    version?: string | undefined;
    releaseGroups?: number[] | undefined;
}

export class MyNmea2kMessage implements IMyNmea2kMessage {
    type?: string | undefined;
    nmea2k?: string | undefined;

    constructor(data?: IMyNmea2kMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.type = data["type"];
            this.nmea2k = data["nmea2k"];
        }
    }

    static fromJS(data: any): MyNmea2kMessage {
        data = typeof data === 'object' ? data : {};
        let result = new MyNmea2kMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["nmea2k"] = this.nmea2k;
        return data; 
    }
}

export interface IMyNmea2kMessage {
    type?: string | undefined;
    nmea2k?: string | undefined;
}

export class MyTestMessage implements IMyTestMessage {
    myTest?: string | undefined;
    type?: string | undefined;

    constructor(data?: IMyTestMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.myTest = data["myTest"];
            this.type = data["type"];
        }
    }

    static fromJS(data: any): MyTestMessage {
        data = typeof data === 'object' ? data : {};
        let result = new MyTestMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["myTest"] = this.myTest;
        data["type"] = this.type;
        return data; 
    }
}

export interface IMyTestMessage {
    myTest?: string | undefined;
    type?: string | undefined;
}

export class LoggedOutRequest implements ILoggedOutRequest {

    constructor(data?: ILoggedOutRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
    }

    static fromJS(data: any): LoggedOutRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LoggedOutRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }
}

export interface ILoggedOutRequest {
}

export class GetWifiStationsResponse implements IGetWifiStationsResponse {
    readonly stations?: WifiStation[] | undefined;

    constructor(data?: IGetWifiStationsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["stations"])) {
                (<any>this).stations = [] as any;
                for (let item of data["stations"])
                    (<any>this).stations!.push(WifiStation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetWifiStationsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWifiStationsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.stations)) {
            data["stations"] = [];
            for (let item of this.stations)
                data["stations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetWifiStationsResponse {
    stations?: WifiStation[] | undefined;
}

export class WifiStation implements IWifiStation {
    name?: string | undefined;
    strength?: number | undefined;
    strength1To5?: number | undefined;
    isSecured?: boolean | undefined;
    isConnected?: boolean | undefined;

    constructor(data?: IWifiStation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.strength = data["strength"];
            this.strength1To5 = data["strength1To5"];
            this.isSecured = data["isSecured"];
            this.isConnected = data["isConnected"];
        }
    }

    static fromJS(data: any): WifiStation {
        data = typeof data === 'object' ? data : {};
        let result = new WifiStation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["strength"] = this.strength;
        data["strength1To5"] = this.strength1To5;
        data["isSecured"] = this.isSecured;
        data["isConnected"] = this.isConnected;
        return data; 
    }
}

export interface IWifiStation {
    name?: string | undefined;
    strength?: number | undefined;
    strength1To5?: number | undefined;
    isSecured?: boolean | undefined;
    isConnected?: boolean | undefined;
}

export class ConnectToWifiStationRequest implements IConnectToWifiStationRequest {
    wifiStationName?: string | undefined;
    wifiStationPassword?: string | undefined;
    deviceId?: string | undefined;

    constructor(data?: IConnectToWifiStationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.wifiStationName = data["wifiStationName"];
            this.wifiStationPassword = data["wifiStationPassword"];
            this.deviceId = data["deviceId"];
        }
    }

    static fromJS(data: any): ConnectToWifiStationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectToWifiStationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wifiStationName"] = this.wifiStationName;
        data["wifiStationPassword"] = this.wifiStationPassword;
        data["deviceId"] = this.deviceId;
        return data; 
    }
}

export interface IConnectToWifiStationRequest {
    wifiStationName?: string | undefined;
    wifiStationPassword?: string | undefined;
    deviceId?: string | undefined;
}

export class ConnectToWifiStationResponse implements IConnectToWifiStationResponse {
    connected?: boolean | undefined;
    connectedIp?: string | undefined;

    constructor(data?: IConnectToWifiStationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.connected = data["connected"];
            this.connectedIp = data["connectedIp"];
        }
    }

    static fromJS(data: any): ConnectToWifiStationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectToWifiStationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connected"] = this.connected;
        data["connectedIp"] = this.connectedIp;
        return data; 
    }
}

export interface IConnectToWifiStationResponse {
    connected?: boolean | undefined;
    connectedIp?: string | undefined;
}

export class DisconnectFromWifiStationRequest implements IDisconnectFromWifiStationRequest {
    deviceId?: string | undefined;

    constructor(data?: IDisconnectFromWifiStationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deviceId = data["deviceId"];
        }
    }

    static fromJS(data: any): DisconnectFromWifiStationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DisconnectFromWifiStationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        return data; 
    }
}

export interface IDisconnectFromWifiStationRequest {
    deviceId?: string | undefined;
}

export class DisconnectFromWifiStationResponse implements IDisconnectFromWifiStationResponse {

    constructor(data?: IDisconnectFromWifiStationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
    }

    static fromJS(data: any): DisconnectFromWifiStationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DisconnectFromWifiStationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }
}

export interface IDisconnectFromWifiStationResponse {
}

export enum N2KFluidLevelEventType {
    Fuel = "Fuel",
    Water = "Water",
    GrayWater = "GrayWater",
    LiveWell = "LiveWell",
    Oil = "Oil",
    BlackWater = "BlackWater",
}

export enum N2KGnssEventType {
    Gps = "Gps",
    Glonass = "Glonass",
    GpsGlonass = "GpsGlonass",
    GpsBasWaas = "GpsBasWaas",
    GpsBasWaasGlonass = "GpsBasWaasGlonass",
    Chayka = "Chayka",
    Integrated = "Integrated",
    Surveyed = "Surveyed",
    Galileo = "Galileo",
}

export enum N2KGnssEventMethod {
    NoGnss = "NoGnss",
    GnssFix = "GnssFix",
    Dgnss = "Dgnss",
    PreciseGnss = "PreciseGnss",
}

export enum N2KHeadingEventReference {
    True = "True",
    Magnetic = "Magnetic",
}

export enum N2KRudderEventDirectionOrder {
    NoDirectionOrder = "NoDirectionOrder",
    MoveToStarboard = "MoveToStarboard",
    MoveToPort = "MoveToPort",
}

export enum N2KSpeedEventReference {
    Paddlewheel = "Paddlewheel",
    Pitottube = "Pitottube",
    DopplerLog = "DopplerLog",
    UltraSound = "UltraSound",
    ElectroMagnetic = "ElectroMagnetic",
    Error = "Error",
    Unavailable = "Unavailable",
}

export enum N2KTemperatureEventSource {
    Sea = "Sea",
    Outside = "Outside",
    Inside = "Inside",
    EngineRoom = "EngineRoom",
    MainCabin = "MainCabin",
    LiveWell = "LiveWell",
    BaitWell = "BaitWell",
    Refridgeration = "Refridgeration",
    HeatingSystem = "HeatingSystem",
    DewPoint = "DewPoint",
    ApparentWindChill = "ApparentWindChill",
    TheoreticalWindChill = "TheoreticalWindChill",
    HeatIndex = "HeatIndex",
    Freezer = "Freezer",
    ExhaustGas = "ExhaustGas",
    Unknown = "Unknown",
}

export enum N2KWindEventReference {
    TrueNorth = "TrueNorth",
    Magnetic = "Magnetic",
    Apparent = "Apparent",
    TrueBoat = "TrueBoat",
    TrueWater = "TrueWater",
}

export class ApiException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if(result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}